import type {ReactElement} from 'react';
import React from 'react';
import styles from '@Components/download-panel/components/download-quality-option/download-quality-option.module.scss';
import {Text, TextSize} from '@Components/text';
import {QualityItem} from '@Components/download-panel/components/quality-item/quality-item';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';

enum PDFQuality {
  SMALL = 'small',
  PRINT = 'print',
}

export function DownloadPdfQualityOption(): ReactElement | null {
  const {fileType, isPDFWebQuality, setIsPDFWebQuality} = useDownloadPanelData();

  if (fileType !== FileTypeOptions.PDF) {
    return null;
  }
  const onClickHandler = (id: PDFQuality): void => {
    switch (id) {
      case PDFQuality.PRINT:
        setIsPDFWebQuality(false);
        break;
      case PDFQuality.SMALL:
      default:
        setIsPDFWebQuality(true);
    }
  };

  return (
    <div className={`flex flex-v-row ${styles.container}`}>
      <Text bold size={TextSize.XSMALL} val={window.i18next.t('pmwjs_quality')} />
      <div className={`flex-h-row ${styles.gap}`}>
        <QualityItem
          onClick={(id): void => {
            onClickHandler(id as PDFQuality);
          }}
          id={PDFQuality.SMALL}
          text={window.i18next.t('pmwjs_standard')}
          isSelected={isPDFWebQuality}
          bullets={[
            {
              text: window.i18next.t('pmwjs_pdf_standard_description_small'),
              showSuccessBullet: false,
            },
          ]}
        />
        <QualityItem
          id={PDFQuality.PRINT}
          text={window.i18next.t('pmwjs_print')}
          onClick={(id): void => {
            onClickHandler(id as PDFQuality);
          }}
          isSelected={!isPDFWebQuality}
          bullets={[
            {
              text: window.i18next.t('pmwjs_pdf_print_description_small'),
              showSuccessBullet: true,
            },
          ]}
        />
      </div>
    </div>
  );
}
